import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';

/** Price display with optional weight and discount badge. */
export function CardPrice(): JSX.Element {
  const { displayPrice, standardPrice, discount, showWeight, weight } = useCardContext();

  return (
    <Price>
      <ActivePrice>
        {displayPrice}
        {showWeight && <Weight> - {weight}</Weight>}
      </ActivePrice>

      {discount && (
        <DiscountedPrice>
          <OriginalPrice>{standardPrice}</OriginalPrice>
          <Discount>{discount}</Discount>
        </DiscountedPrice>
      )}
    </Price>
  );
}

const Price = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 4px;
  margin: 16px 0 8px;
  width: 100%;
`;

const ActivePrice = styled.div`
  color: #2c3236;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
`;

const Weight = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: ${20 / 14};
`;

const DiscountedPrice = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: var(--justify-content);
`;

const OriginalPrice = styled.div`
  color: #485055;
  font-size: 14px;
  line-height: 1;
  text-decoration: line-through;
`;

const Discount = styled.div`
  background: ${({ theme }) => theme.customized.colors.discountTag};
  border-radius: ${({ theme }) => theme.customized.radius.tags};
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 1;
  margin-left: 2px;
  padding: 2px 6px;
  white-space: nowrap;
`;
